<template>
  <!-- 顶部导航 右侧登录成功后的组件 --11-- -->
  <div class="personalRoute_component" @click.stop @click="isshow=!isshow">
      <div class="personalRoute_left_img"><img src="@/assets/logo.png" alt=""></div>
      <div class="personalRoute_left_name">
          <span>forward</span>
          <img src="@/assets/jianTou.png" alt="" :style="{transform:isshow?'rotate(180deg)':'rotate(90deg)'}">
      </div>
      <transition name="el-zoom-in-top">
        <div class="personalRouteDropDown_box" v-show="isshow">
            <ul>
                <li v-for="(item,index) in list" :key="index" @click="goPerRouter(item)">
                    <i :class="item.icon"></i>
                    {{item.name}}
                </li> 
            </ul>
        </div> 
      </transition>
  </div>
</template>

<script> 
export default {
  name: 'personalRoute_component',
  data () {
    return {
       isshow:false,
       list:[
           {name:"个人中心",path:"/personalCenter/account",icon:"el-icon-s-custom"}, 
           {name:"使用方",path:"/personalCenter/flow",icon:"el-icon-s-opportunity"},
           {name:"退出",path:"/",icon:"el-icon-s-help"}
       ]
    }
  },
  methods:{
       goPerRouter(item){
           this.$router.push({path:item.path})
       }
  },
  mounted(){
      document.body.addEventListener('click',  () => {
        this.isshow = false
      })
  },
  components:{
     
  }
}
</script>

<style scoped lang="less">
.personalRoute_component{
    display: flex;
    cursor: pointer;
    // width: 184px;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .personalRoute_left_img{
        width: 24px;
        height: 24px;
        background: #e2e2e2;
        border-radius: 50%;
        overflow: hidden;
        text-align: center;
        line-height: 24px;
        img{
            height: 100%;
        }
    }
    .personalRoute_left_name{
        display: flex;
        padding: 0 0 0 10px;
        align-items: center;
        justify-content: space-between;
        span{
            padding-right: 5px;
        }
        img{
            height: 12px;
            transition: 0.3s;
        }
    }
}
.personalRouteDropDown_box{
        position: absolute;
        // right: 0;
        left: 50%; 
        transform: translateX(-50%);
        top:60px; 
        padding: 10px 20px;
        border-radius:6px;
        background: #333333;
        color:#ffffff;
        ul{
            li{
                width:100px;
                height:28px;
                border-radius:4px;
                text-align: center;
                line-height: 28px;
            }
            li:hover{
                background:rgba(102,102,102,1);
            }
            li:active{
                background:rgba(102,102,102,0.8);
            }
        }
}
.personalRouteDropDown_box:after{
    content: "";
    position:absolute;
    top:-5px;
    right: 10px;
    width:0;
    height:0;
    border-left:5px solid transparent;
    border-right:5px solid transparent;
    border-bottom:8px solid #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/headerComponent/components/personalRoute.vue